import Swal from 'sweetalert2';

/**
 * Menampilkan dialog konfirmasi
 * @param {object} options - opsi swal.fire seperti title, text, confirmButtonText, dll.
 * @returns {Promise} - hasil konfirmasi
 */
export const showConfirm = (options = {}) => {
  return Swal.fire({
    title: options.title || 'Apakah Anda yakin?',
    text: options.text || 'Tindakan ini tidak bisa dibatalkan!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#6c757d',
    confirmButtonText: 'Ya, hapus!',
    cancelButtonText: 'Batal',
    ...options,
  });
};
